import React from "react";
import Modal from "src/components/Shared/Modal";
import { apiRequest } from "src/async/apiUtils";
import { toast } from "react-toastify";
import { useAsyncAction } from "src/hooks/useAsyncAction";

const NotificationDeleteModal = ({ deleteId, setDeleteId, onSuccess }) => {
  const {
    loading: deleting,
    success: deleted,
    execute: deleteNotification,
  } = useAsyncAction({
    onSuccess: onSuccess,
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const handleDeleteNotification = () => {
    deleteNotification(async () => {
      const params = { notification_id: deleteId };
      const url = `/notifications/:notification_id`;
      await apiRequest("delete", url, { params });
    });
  };

  return (
    <Modal
      size="lg"
      title="Notification"
      secondaryTitle="Delete"
      isOpen={Boolean(deleteId)}
      onCancel={() => setDeleteId(null)}
      onSuccess={handleDeleteNotification}
      isLoading={deleting}
      defaultOptions={{
        onSuccessButtonText: "Delete",
        onSuccessButtonSuccess: deleted,
      }}>
      Are you sure you want to delete this notification ?
    </Modal>
  );
};

export default NotificationDeleteModal;
